<div class="pr-row">

  <input
    pInputText
    [ngModel]="key"
    (ngModelChange)="key = $event; onChange()"
    placeholder="Key"
    class="pr-key-input"
  />

  <span class="pr-eq">=</span>

  <input
    pInputText
    [ngModel]="value"
    (ngModelChange)="value = $event; onChange()"
    placeholder="Value"
    class="pr-value-input"
  />

  <button
    pButton
    type="button"
    icon="pi pi-trash"
    class="p-button-text p-button-danger p-button-sm pr-remove-btn"
    pTooltip="Remove this parameter"
    tooltipPosition="top"
    (click)="remove.emit()"
  ></button>

</div>
